// "Ally needs login — its July rows may be missing. Preview built from
// Chase only." (`#s07` phone). The proposal is still shown; the caller is
// told a source is missing rather than silently getting a partial answer.
export function AskDegradedSourceBanner({ institutionName, reason: _reason }: { institutionName: string; reason: string }) {
  return (
    <div
      className="rounded-lg border border-degraded-border bg-degraded-surface px-3 py-2.5 text-xs text-degraded-foreground"
      data-testid="ask-degraded-source-banner"
    >
      {institutionName} needs login — its rows may be missing. Preview built from the remaining accounts
      only. <a href="/connect" className="font-semibold underline">Reconnect</a>
    </div>
  );
}

export default AskDegradedSourceBanner;
